import axios from "../../utils/axiosConfig";
import { AddCategoryDTO , AddSubscriptionDTO, EditCategoryDTO, EditSubscriptionStatusDTO} from "../../dtos/category";
 
axios.defaults.withCredentials = true;

const getSubscription = async () => {
  const { data } = await axios.get( "/api/pharmacy_subscription_package/get_pharmacy_subscription_package");
  return data;
};
const AddSubscription = async (subscription: AddSubscriptionDTO ) => {
  const { data } = await axios.post( `/api/pharmacy_subscription/add_pharmacy_subscription`, subscription);
  return data;
};
// const getSubscriptionStatus = async (pharmacy_id: any) => {
//   const { data } = await axios.get( `/api/pharmacy_subscription/check_pharmacy_subscription_status?pharmacy_id=${pharmacy_id}`);
//   return data;
// };
const getSubscriptionStatus = async (pharmacy_id: any) => {
  const { data } = await axios.get( `/api/pharmacy_subscription/check_pharmacy_current_status?pharmacy_id=${pharmacy_id}`);
  return data;
};
const editSubscriptionStatus = async (dto: EditSubscriptionStatusDTO) => {
  const { data } = await axios.put( `/api/pharmacy_subscription/update_pharmacy_subscription_model`, dto);
  return data;
};
const SubscriptionService = {
  getSubscription,
  AddSubscription,
  getSubscriptionStatus,
  editSubscriptionStatus,
};

export default SubscriptionService;